import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Flexer, Button, Icon } from '@ontruck/orc';

const t = {
  new: 'Create new recurring order configuration',
  edit: 'Edit recurring order configuration',
  cancel: 'Cancel all orders',
};

const FormModalHeader = ({ initialRecurringOrder, showCancelButton, isNew, onCancelClick }) => {
  return (
    <Flexer.Parent alignItems="center" justifyContent="space-between">
      <Flexer.Parent alignItems="center">
        <Icon glyph="repeat" size="2.4rem" color="greyWolf" />
        <div>{isNew ? t.new : t.edit}</div>
      </Flexer.Parent>
      <Fragment>
        <Flexer.Child>
          {showCancelButton && <Button skin="cancel" text={t.cancel} onClick={onCancelClick} />}
        </Flexer.Child>
      </Fragment>
    </Flexer.Parent>
  );
};

FormModalHeader.propTypes = {
  showCancelButton: PropTypes.bool,
  isNew: PropTypes.bool,
  onCancelClick: PropTypes.func.isRequired,
  initialRecurringOrder: PropTypes.object.isRequired,
};

FormModalHeader.defaultProps = {
  showCancelButton: true,
  isNew: false,
  initialRecurringOrder: {},
};

export default FormModalHeader;
